import { useModeration } from '../contexts/ModerationContext'

export function useGlobalModeration() {
    return useModeration()
}
